import { useEffect, useRef, useState } from 'react'
import HelperDate, { dateFormat } from 'utils/helper-date'

const useDatetime = ( { updateInterval = 1000 * 60 } = {} ) => {
	
	const intervalRef = useRef();
	
	const getDatetime = () => {
		return HelperDate.date().format( dateFormat.DATE_TIME )
	}
	
	const [ date, setDate ] = useState( getDatetime() )
	
	useEffect(() => {
		intervalRef.current = setInterval(() => {
			setDate( getDatetime() )
		}, updateInterval )
		
		return () => {
			clearInterval( intervalRef.current )
		}
	}, [])
	
	return date
}

export default useDatetime
